import uuid from 'uuid/v4';
import moment from 'moment';
import { addDeletedEntry } from './deleted';

export const ADD_SILO = 'silos/ADD_SILO';
export const EDIT_SILO = 'silos/EDIT_SILO';
export const REMOVE_SILO = 'silos/REMOVE_SILO';
export const LOAD_SILOS = 'silos/LOAD_SILOS';

export function addSilo(data) {
  return dispatch => {
    data.edited = true;
    data.id = uuid();
    data.created_at = moment().valueOf();
    data.updated_at = 0;
    dispatch({
      type: ADD_SILO,
      data
    });

    return data.id;
  }
}

export function editSilo(data) {
  return dispatch => {
    data.edited = true;
    data.updated_at = moment().valueOf();
    dispatch({
      type: EDIT_SILO,
      data
    });
  }
}

export function removeSilo(id) {
  return dispatch => {
    addDeletedEntry({
      id,
      table: 'silos'
    });

    dispatch({
      type: REMOVE_SILO,
      id
    });
  }
}